<template>
  <div class="talentList" @click="handlerClick()">
    <div class='list bg_fff cursor_p pr transition_2' v-for="(item, index) in demoData" :key="item.resume._id + item.resume._score">
       <!-- 顶部区域   -->
      <div class="newtop-content bg_fa f_14 color_9c">
        <!-- 顶部左侧  -->
        <div>
          <div class="flex">
            <div :class="['headImg pr']" >  
              <div class="pa img" :style="{backgroundImage:'url('+ (item.resume._source.resume.profile.avatar_url || headImgList.round[item.resume._source.resume.user_id%5]) +')',backgroundSize:'cover'}"></div>
              <div :style="{left:lastActiveAt(item.last_active_at) == '3日内活跃' ?  '-11px' : '-7px'}" class="online-text" v-if="lastActiveAt(item.last_active_at)"><div  class="circle"></div>{{lastActiveAt(item.last_active_at)}}</div>
            </div>
            <div class="user-info">
              <div class="flex">
                <!-- 用户名 -->
                <div class="new-username">
                  <div class="name color_40 f_18 font_w_b pr fl" >{{item.resume._source.resume.basic_info.name}}</div>
                  <!-- <div class="onlineAt f_14 color_9c fl" v-if="lastActiveAt(item.last_active_at)" >{{lastActiveAt(item.last_active_at)}}</div> -->
                </div>
                <div class="leftItem color_40 f_14 beforeText" style="margin-bottom:10px">
                  <!-- 年纪 -->
                  <span class="display_ib" v-if="getAge(item.resume._source.resume.profile.birthday)" >{{getAge(item.resume._source.resume.profile.birthday)}}</span>
                  <!-- 工作年限/毕业时间 -->
                  <span class="display_ib" v-if="workingYears({profession_identity:item.profession_identity, years_of_work_experience:item.years_of_work_experience, selectedeXperience:searchListObj.selectedeXperience, graduate_at:item.resume._source.resume.basic_info.graduate_at})" >{{workingYears({profession_identity:item.profession_identity, years_of_work_experience:item.years_of_work_experience, selectedeXperience:searchListObj.selectedeXperience, graduate_at:item.resume._source.resume.basic_info.graduate_at})}}</span>
                  <!-- 最高学历 -->
                  <span class="display_ib" v-if="item.resume._source.resume.education_experiences && item.resume._source.resume.education_experiences[item.recent_edu_index]" >{{item.resume._source.resume.education_experiences[item.recent_edu_index].degree}}</span>
                </div>
              </div>
              <div class="text beforeText fl color_40">
                期望：
                <span class="display_ib" v-if="(item.resume._source.resume.basic_info.predicted_location && item.resume._source.resume.basic_info.predicted_location.length) || (item.resume._source.resume.basic_info.expected_location && item.resume._source.resume.basic_info.expected_location.length)">{{item.resume._source.resume.basic_info.predicted_location.length ? item.resume._source.resume.basic_info.predicted_location.join('/') : item.resume._source.resume.basic_info.expected_location.join('/')}}</span>
                <span class="display_ib" v-if="item.resume._source.resume.profile.exp_job">{{item.resume._source.resume.profile.exp_job}}</span>
                <span class="display_ib">{{expected_salary(item.resume._source.resume.profile.expected_salary) || '面议'}}</span>
              </div>
              <!-- <div class="permissionState f_14 color_9c fr" v-if="!!item.hr_permission_state">{{item.hr_permission_state | hrPermissionState}}</div> -->
            </div>
          </div>
          <div class="highligt-body">
            <div v-for="(sitem,index) in heighlightTags[item.cv_account_token]" :key="index + 'a' + item._id"  class="highlight">{{sitem}}</div>
            <div v-for="(sitem,index) in skillTags[item.cv_account_token]" :key="index + 'b' + item._id"  class="skill-tags highlight">{{sitem}}</div>
          </div>
        </div>
        <!-- 顶部右侧 -->
        <div class="standard-btn-content">
            <el-tooltip class="item" effect="dark" content="该人才可直接获取电话" placement="top-end">
              <div class="standard-btn-left">
                <span class="iconfont iconGroup311"></span>
                {{!item.hr_permission_state && !item.delivery_status ? '联系Ta' : '继续沟通'}}
              </div>
            </el-tooltip>
            <div class="standard-btn-right">
              <span class="iconfont pr" :class="[item.is_favorite ? 'iconfavoritesactive star color_ffc':'iconfavorites star color_40']"></span>
              {{item.is_favorite?'移除储备':'储备'}}
            </div>
        </div> 
      </div>

      <div class="userInfo flex new-content">
        <!-- 中间内容区域 -->
        <div class="centerContent flex1 clearfix" :class="[searchListObj.keyword_seg.length && highlightLength(item, item.resume._source.resume, item.keyword_hit).l ? '' : 'hasHighlightLength']">
          <div class="fl flex" style="overflow: inherit; width: 100%;">
            <!-- 工作经历 -->
            <div class="work-list pr flex1">
              <!-- 左侧分割线 -->
              <div class="divid pa text_center color_fff">
                <div class="start iconfont iconGroup32 pa"></div>
              </div>
              <div class="item" v-if="!(filterWork(item.resume._source.resume.work_experiences).length + filterWork(item.resume._source.resume.internship_experiences).length)">
                <div class="name f_14 color_40 beforeText">暂无工作经历</div>
              </div>

              <template >
                <!-- 有工作经历 -->
                <template v-if="filterWork(item.resume._source.resume.work_experiences).length">
                  <template v-for="(item,index) in filterWork(item.resume._source.resume.work_experiences, item.keyword_hit)" >
                    <div class="item" :key="String(index)" v-if="index<2">
                      <div class="text f_12 color_9c beforeText mr48">
                        <span class="display_ib time" v-if="item.start_at||item.end_at || item.present">
                          <i v-if="item.start_at">{{splitTime(item.start_at)}}</i>
                          <i v-if="item.end_at || item.present">{{splitTime(item.end_at || item.present)}}</i>
                        </span>
                        <span class="display_ib">就职</span>
                        <span class="display_ib" v-if="getWorkTimeLength({start_at: item.start_at, end_at: item.end_at, present:item.present})">{{getWorkTimeLength({start_at: item.start_at, end_at: item.end_at, present:item.present})}}</span>
                      </div>
                      <div class="name f_14 color_40 beforeText ellipsis">
                        <span v-if="item.company_name" v-html="item.company_name"></span>
                        <span v-if="item.job_title" v-html="item.job_title"></span>
                      </div>
                    </div>
                  </template>
                </template>

                <!-- 实习经历 -->
                <template v-if="filterWork(item.resume._source.resume.work_experiences).length<2 && filterWork(item.resume._source.resume.internship_experiences).length">
                  <template v-for="(sitem,sindex) in filterWork(item.resume._source.resume.internship_experiences, item.keyword_hit)" >
                    <div class="item" :key="String(sindex)" v-if="sindex < (filterWork(item.resume._source.resume.work_experiences).length ? 1 : 2)">
                      <div class="text f_12 color_9c beforeText mr48">
                        <span class="display_ib time" v-if="sitem.start_at||sitem.end_at || sitem.present">
                          <i v-if="sitem.start_at">{{splitTime(sitem.start_at)}}</i>
                          <i v-if="sitem.end_at || sitem.present">{{splitTime(sitem.end_at || sitem.present)}}</i>
                        </span>
                        <span class="display_ib">实习</span>
                        <span class="display_ib" v-if="getWorkTimeLength({start_at: sitem.start_at, end_at: sitem.end_at, present:sitem.present})">{{getWorkTimeLength({start_at: sitem.start_at, end_at: sitem.end_at, present:sitem.present})}}</span>
                      </div>
                      <div class="name f_14 color_40 beforeText ellipsis">
                        <span v-if="sitem.company_name" v-html="sitem.company_name"></span>
                        <span v-if="sitem.title" v-html="sitem.title"></span>
                      </div>
                    </div>
                  </template>
                </template>
                
                <!-- 项目经历 -->
                <template v-if="(filterWork(item.resume._source.resume.work_experiences).length + filterWork(item.resume._source.resume.internship_experiences).length)<2 && filterCustomSections(item.resume._source.resume.project_experiences).length">
                  <template v-for="(sitem, sindex) in filterCustomSections(item.resume._source.resume.project_experiences)" >
                    <div class="item" :key="'project_experiences'+sindex" v-if="sindex<1">
                      <div class="text f_12 color_9c beforeText mr48">
                        <span class="display_ib time" v-if="sitem.start_at||sitem.end_at || sitem.present">
                          <i v-if="sitem.start_at">{{splitTime(sitem.start_at)}}</i>
                          <i v-if="sitem.end_at || sitem.present">{{splitTime(sitem.end_at || sitem.present)}}</i>
                        </span>
                        <span class="display_ib">项目</span>
                      </div>
                      <div class="name f_14 color_40 beforeText ellipsis">
                        <span v-if="sitem.name">{{sitem.name}}</span>
                        <span v-if="sitem.title">{{sitem.title}}</span>
                      </div>
                    </div>
                  </template>
                </template>
                <!-- 社团经历 -->
                <template v-if="(filterWork(item.resume._source.resume.work_experiences).length + filterWork(item.resume._source.resume.internship_experiences).length)<2 && !filterCustomSections(item.resume._source.resume.project_experiences).length && filterInfoSections(item.resume._source.resume.orgs).length">
                  <template v-for="(sitem, sindex) in filterInfoSections(item.resume._source.resume.orgs)" >
                    <div class="item" :key="'orgs'+sindex" v-if="sindex<1">
                      <div class="text f_12 color_9c beforeText mr48">
                        <span class="display_ib time" v-if="sitem.start_at||sitem.end_at || sitem.present">
                          <i v-if="sitem.start_at">{{splitTime(sitem.start_at)}}</i>
                          <i v-if="sitem.end_at || sitem.present">{{splitTime(sitem.end_at || sitem.present)}}</i>
                        </span>
                        <span class="display_ib">社团</span>
                      </div>
                      <div class="name f_14 color_40 beforeText">
                        <span v-if="sitem.name">{{sitem.name}}</span>
                        <span v-if="sitem.title">{{sitem.title}}</span>
                      </div>
                    </div>
                  </template>
                </template>
                <!-- 教育经历 -->
                <template v-if="item.resume._source.resume.education_experiences.length > 0" >
                  <template v-for="(sitem,sindex) in item.resume._source.resume.education_experiences" >
                    <div v-if="sindex < 2" class="item"  :key="sindex + 'm'">                                    
                      <div v-if="sindex == 0" class="divid-end text_center color_fff iconfont iconGroup12 pa"></div> 
                      <div class="text f_12 color_9c mr48">
                        <span class="display_ib time" v-if="sitem.start_at">{{splitTime(sitem.start_at.split(' ')[0])}}</span> -
                        <span v-if="sitem.end_at">{{splitTime(sitem.end_at.split(' ')[0])}}</span>
                      </div>
                      <template v-for="(titem, tindex) in schoolHtml(item)">
                        <div  class="leftItem color_40 f_14 clearfix flex-c-content" :key="tindex+'_'+titem" v-if="tindex == sindex" v-html="titem"></div>
                      </template>
                    </div>
                  </template>  
                </template>
              </template>
            </div>
          </div>

        </div>

        
      </div>

      <div class="message clearfix color_9c f_14 searchIndex" v-if="searchListObj.keyword_seg.length && highlightLength(item, item.resume._source.resume, item.keyword_hit, index).l">
        <!-- 匹配词卡片 -->
        <template v-for="(value,key) in highlightLength(item, item.resume._source.resume, item.keyword_hit).labels">
          <div class="fl color_blue f_14" :key="key" v-if="value<1">{{key}}</div>
        </template>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {mixinsUtils} from '@/mixins/search/utils'
import { filterInfoSections, filterCustomSections, getAge, applied_at, getDegreeName, getWorkTimeLength } from '@/utils/resumeList'

export default {
  name: 'searchTalentPage',
  mixins:[mixinsUtils],
  props:{
    demoData: {},
    selectedeXperience:{}, //选中的经验
  },
  data(){
    return {
      skillTags:{
        "cv88029c0147ae4f41": ['用户产品','产品设计','需求分析','数据分析','用户研究','办公软件','项目管理','交互设计','原型设计','产品规划'],
        "cv54400cf489db4904": ['Java','Golang','CSS','SQL','PHP','Spring','MySQL','Docker','数据结果','消息队列','功能模块设计'],
        "cva5997cab5c5f4043": ['Sketch','AE','Photoshop','UI设计','交互体验设计','动效设计','海报设计','插画']
      },
       heighlightTags:{
        "cv88029c0147ae4f41": ['名企'],
        "cv54400cf489db4904": ['名企','技术达标'],
        "cva5997cab5c5f4043": ['名企']
      }
    }
  },
  computed:{
    ...mapState('resumeDetails',['searchListObj'])
  },
  methods:{
    handlerClick () {
      this.$emit('customClick')
    },
    //判断是否满足为匹配上的判断
    highlightLength(listItem, resume, keywordsBat, index){
      // 匹配词转小写
      keywordsBat = keywordsBat.map(item=>item.toLowerCase());
      // 初始化对象
      let keywordsBatHighlightLength = {};
      keywordsBat.forEach(key=>{
        keywordsBatHighlightLength[key] = 0
      })

      //拿到过滤之后的公司列表
      if(resume.work_experiences){
        let workList = this.filterWork(resume.work_experiences, keywordsBat);
        if(workList.length){
          workList.forEach((item,index)=>{
            let company_name = item.company_name.split(`<span class="es-highlighter">`).join('').split('</span>').join('').toLowerCase();
            let job_title = item.job_title.split(`<span class="es-highlighter">`).join('').split('</span>').join('').toLowerCase();
            
            if(index<2){
              keywordsBat.forEach(key=>{
                if(company_name.includes(key) || job_title.includes(key)){
                  keywordsBatHighlightLength[key] = keywordsBatHighlightLength[key]+1
                }
              })
            }
          })
        }
      }
      let schoolHtml = this.schoolHtml(listItem);
      schoolHtml.forEach((item,index)=>{
        schoolHtml[index] = item.replace(/\<i class="es-highlighter">/g, '' )
        schoolHtml[index] = item.replace(/\<\/i>/g, '' );
      })
      keywordsBat.forEach(key=>{
        schoolHtml.forEach((item,index)=>{
          if(item.includes(key) && index<2){
            keywordsBatHighlightLength[key] = keywordsBatHighlightLength[key]+1
          }
        })
      })

      let l = 0;
      for (let key in keywordsBatHighlightLength) {  
        if(keywordsBatHighlightLength[key]<1){
          l+=1
        }
      } 
      return {
        labels:keywordsBatHighlightLength,
        l
      }
    },
    //过滤空公司信息
    filterWork(work_experiences, keyword_hit=[]){
      // console.log(work_experiences)
      if(!work_experiences){
        return []
      }
      let workList = []
      work_experiences = JSON.parse(JSON.stringify(work_experiences));
      work_experiences.forEach(item=>{
        let company_name = item.company_name || ''
        let job_title = item.job_title || '';
        // let reg = '';
        // let str = '';
        // for (let i = 0; i < keyword_hit.length; i++) {
        //   if (str) str += '|'
        //   str += keyword_hit[i];
        // }
        // reg = RegExp(`.*?(${str}).*?`, 'gim');
        // item.company_name = company_name.replace(reg, `<span class="es-highlighter">$1</span>`)
        // item.job_title = job_title.replace(reg, `<span class="es-highlighter">$1</span>`)
        keyword_hit.forEach(sitem=>{
          if(sitem.length>1){
            let sitemText = sitem.replace(/\+/g,'\\+').replace(/\|/g,'\\|').replace(/\^/g,'\\^').replace(/\$/g,'\\$').replace(/\*/g,'\\*').replace(/\./g,'\\.');
            company_name = company_name.replace(new RegExp(sitemText,'g'),`<span class="es-highlighter">${sitem}</span>`)
            job_title = job_title.replace(new RegExp(sitemText,'g'),`<span class="">${sitem}</span>`)
          }
        })
        
        if(company_name || job_title){
          workList.push(item)
        }
      })
      return workList;
    },
    filterInfoSections, //过滤模块
    filterCustomSections, //获取自定义模块数据
    getAge, //获取年龄
    applied_at, //时间
    getDegreeName, //获取专业名称
    getWorkTimeLength,

  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/css/components/resumeList.scss';
</style>